module.exports = __webpack_public_path__ + "static/media/icon_a.662e4e2b.svg";